import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import { IMediaLink } from '@opengov/stories-shared/types';
import React, { useEffect, useState } from 'react';

import { IOnlinePublicationMessages } from '../../../../../types';

import { styles } from './MediaLink.styles';

export type IMediaLinkProps = {
  mediaLinkPosition: number;
  mediaLink: IMediaLink;
  messages: IOnlinePublicationMessages;
  removeLinkFromMedia(id: string): void;
  updateMedialinks(mediaId?: string, value?: string, type?: string): void;
};

export const MediaLink = (props: IMediaLinkProps) => {
  const { mediaLinkPosition, mediaLink, messages, removeLinkFromMedia, updateMedialinks } = props;

  const [title, setTitle] = useState(mediaLink.title);
  const [link, setLink] = useState(mediaLink.link);

  useEffect(() => {
    setTitle(mediaLink.title);
    setLink(mediaLink.link);
  }, [mediaLink]);

  const isFirst = mediaLinkPosition === 0;

  return (
    <Box data-test="media-link">
      <Box sx={isFirst ? styles.firstRow : styles.row}>
        <TextField
          label={isFirst ? messages.linkName : undefined}
          placeholder={messages.enterName}
          value={title}
          size="small"
          inputProps={{ maxLength: 60, className: 'no-format', 'aria-label': messages.linkName }}
          sx={styles.linkNameInput}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={(e) => updateMedialinks(mediaLink.id, e.target.value, messages.title)}
        />
        <TextField
          label={isFirst ? messages.linkURL : undefined}
          placeholder={messages.linkURLDescription}
          value={link}
          size="small"
          inputProps={{ className: 'no-format', 'aria-label': messages.linkURL }}
          sx={styles.linkURLInput}
          onChange={(e) => setLink(e.target.value)}
          onBlur={(e) => updateMedialinks(mediaLink.id, e.target.value, messages.link)}
        />
        <Tooltip title={'Delete'}>
          <IconButton
            size="small"
            data-test="delete"
            aria-label="Delete link"
            sx={styles.deleteButton}
            onClick={() => removeLinkFromMedia(mediaLink.id)}
          >
            <CloseIcon aria-hidden={true} fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
